export default "__VITE_ASSET__8dffd009__"